<div class="mainContent">

  <div style="height: 7vh;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">Computerized Systems</label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div style="height: 57vh;overflow: auto;padding-left: 4%;padding-right: 4%;">
    
<form [formGroup]="FormValid" novalidate>

  <div class="row mt-2">
    <div class="col-lg-12">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>System Code</mat-label>
        <input
          matInput
          formControlName="systemCode"
          maxlength="100"
          autocomplete="off">

        <mat-error *ngIf="FormValid.get('systemCode')?.hasError('required')">
          System Code is required.
        </mat-error>

        <mat-error *ngIf="FormValid.get('systemCode')?.hasError('maxlength')">
          Maximum 100 characters allowed.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-lg-12">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>System Name</mat-label>
        <input
          matInput
          formControlName="systemName"
          maxlength="200"
          autocomplete="off">

        <mat-error *ngIf="FormValid.get('systemName')?.hasError('required')">
          System Name is required.
        </mat-error>

        <mat-error *ngIf="FormValid.get('systemName')?.hasError('maxlength')">
          Maximum 200 characters allowed.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="row mt-2">
    <div class="col-lg-12">
      <mat-form-field appearance="outline" style="width:100%">
        <mat-label>Description</mat-label>

        <textarea
          matInput
          rows="5"
          formControlName="description"
          maxlength="5000">
        </textarea>

        <mat-hint align="end">
          {{FormValid.get('description')?.value?.length || 0}} / 5000
        </mat-hint>

        <mat-error *ngIf="FormValid.get('description')?.hasError('maxlength')">
          Maximum 5000 characters allowed.
        </mat-error>
      </mat-form-field>
    </div>
  </div>

</form>

  </div>
  <div style="height:5vh">
    <div class="row" style="position:sticky;left:0;bottom:0;width:100%;">

      <div class="col-lg text-center">

        <div style="text-align: end;display:flex; justify-content:flex-end; align-items:center;">
          

          <!-- <form [formGroup]="formValidCheckbox">

                <span *ngIf="buttonName == 'Save'">
                  <mat-checkbox
                    formControlName="isCheckboxSelected"
                    [(ngModel)]="isCheckboxSelected">
                  </mat-checkbox>

                  <span>Create Another</span>
                </span>

          </form> -->

             <!-- <button i18n="@@TargetClear" type="button" (click)="updateData()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">{{this.buttonName}}</button> -->

          <app-common-button
          label={{this.buttonName}}
          title={{this.buttonName}}
          [buttonId]="1111"
          width="110px"
          [critical]="false"
          (clicked)="updateData()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>

           <!-- <button i18n="@@TargetCancel" type="button" (click)="close()"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="backgroundColorButton"
            style="padding: .3rem 1.6rem;font-size: .85rem;width:95px;color: white;">Cancel</button> -->
         
            <app-common-button
          label="Cancel"
          title="Cancel "
          [buttonId]="1111"
          variant="cancel"
          width="110px"
          [critical]="false"
          (clicked)="close()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
        </div>
      </div>
    </div>
  </div>
</div>